export const discountAction= (data) => { 
    return {
       type: data.type,
       data: data.data
    }
 }